import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { Field, Form, getFormValues, reduxForm, } from 'redux-form';
import { required } from 'redux-form-validators';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { availabilityOptions } from 'components/settings/components/sections/dixaMessenger/views/flow/components/nodeTypeAvailability/availabilityModal/availabilityOptions';
import { FlowMessengerNodeAvailabilityStrategy, } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
const defaultAvailabilityStrategy = FlowMessengerNodeAvailabilityStrategy.NoAgentsAvailable;
const AvailabilityModalImpl = (props) => {
    const { node, nodeLabel, triggerClose, handleSubmit, destroy, replaceNode, pristine, formValues, } = props;
    const closeModal = useCallback(() => {
        destroy();
        triggerClose();
    }, [destroy, triggerClose]);
    const notify = useNotifications();
    const handleSaveClick = useCallback((values) => {
        var _a, _b;
        if (!values.query) {
            notify({ title: 'No strategy is selected' }, NotificationType.Error);
            return;
        }
        const availableNextNodeId = ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.availableNextNodeId) || uuid();
        const notAvailableNextNodeId = ((_b = node.payload) === null || _b === void 0 ? void 0 : _b.notAvailableNextNodeId) || uuid();
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], icon: '', text: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.MESSENGER_AVAILABILITY, payload: {
                query: { type: values.query },
                availableNextNodeId,
                notAvailableNextNodeId,
            }, overlay: [] });
        replaceNode(nodeOptions);
        triggerClose();
    }, [node, replaceNode, triggerClose]);
    const disabledSubmit = pristine && formValues.query !== defaultAvailabilityStrategy;
    return (_jsx(Box, Object.assign({ width: "600px" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: closeModal }, { children: "Agent availability is used to check if any agents are available. Availability is decided on whether agents in the downstream Queues are either at Workload Capacity, have their status set to away, or are simply offline." })), _jsx(ModalBody, { children: _jsx(Field, { required: true, name: "query", label: "Agent Availability", placeholder: "Select an availability strategy", validate: [required()], component: FieldSelect, items: availabilityOptions }) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: disabledSubmit }, cancelOnClick: closeModal })] })) })));
};
const formName = 'messengerAvailabilityModalForm';
const mapStateToProps = (state, ownProps) => {
    var _a, _b;
    const formValues = (getFormValues(formName)(state) ||
        {});
    return {
        initialValues: {
            query: (_b = (_a = ownProps.node.payload) === null || _a === void 0 ? void 0 : _a.query.type) !== null && _b !== void 0 ? _b : defaultAvailabilityStrategy,
        },
        formValues,
    };
};
export const AvailabilityModal = connect(mapStateToProps)(reduxForm({
    form: formName,
    enableReinitialize: true,
})(AvailabilityModalImpl));
